package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Text
import androidx.compose.material.TextField
import androidx.compose.material.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.subscribe
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.LandingPageTextField
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun RoundedTextFieldWithButton(
    isMobileView: Boolean = false,
    input: MutableState<String>,
    placeHolder: String,
    modifier: Modifier = Modifier,
    keyboardOptions: KeyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Text),
    enabled: Boolean = true,
    onSubscribe: () -> Unit
) {
    Box(
        modifier = modifier
            .height(60.toScaleDp())
            .fillMaxWidth()
            .clip(RoundedCornerShape(60.toScaleDp()))
            .background(Color.White),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier
                .fillMaxSize(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            TextField(
                textStyle = TextStyle.Default.copy(
                    fontSize = 16.toScaleSp()
                ),
                value = input.value,
                onValueChange = { newValue ->
                    val filteredValue =
                        newValue.filter { it.isLetterOrDigit() || it.isWhitespace() || it in "!@#$%^&*()-_=+[]{}|;:'\",.<>?/`~" }
                    input.value = filteredValue
                },
                placeholder = {
                    Text(
                        placeHolder,
                        color = LandingPageTextField,
                        fontSize = 16.toScaleSp(),
                        lineHeight = 19.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                },
                enabled = enabled,
                modifier = Modifier
                    .weight(2f)
                    .padding(horizontal = 15.toScaleDp()),
                keyboardOptions = keyboardOptions,
                colors = TextFieldDefaults.textFieldColors(
                    backgroundColor = Color.Transparent,
                    focusedIndicatorColor = Color.Transparent,
                    unfocusedIndicatorColor = Color.Transparent
                ),
                singleLine = true
            )
            if (!isMobileView) {
                Button(
                    onClick = {
                        onSubscribe()
                    },
                    enabled = input.value.trim().isNotEmpty(),
                    modifier = Modifier
                        .padding(horizontal = 23.toScaleDp(), vertical = 11.toScaleDp())
                        .weight(1f)
                        .height(55.toScaleDp())
                        .width(142.toScaleDp())
                        .clip(RoundedCornerShape(50.toScaleDp()))
                        .pointerCursorIfEnabled(input.value.trim().isNotEmpty()),
                    colors = ButtonDefaults.buttonColors(
                        backgroundColor = if (input.value.trim()
                                .isNotEmpty()
                        ) BlueApp else BlueApp.copy(alpha = 0.5f)
                    ),
                ) {
                    DisableSelection {
                        Text(
                            text = stringResource(Res.string.subscribe),
                            color = Color.White,
                            fontSize = 16.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            modifier = Modifier.align(Alignment.CenterVertically),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }
        }
    }
}